<template>
  <div class="md-layout text-center">
    <div class="md-layout-item md-size-90 md-medium-size-90 md-small-size-90 md-xsmall-size-100">
      <login-card header-color="green">
        <div slot="title">
          <h4 class="title">Log in</h4>
          <img
            class="img-title"
            src="https://florette-static-pro.azureedge.net/assets/images/logo_tipografico_blanco.png"
          />
        </div>
        <md-field class="md-form-group" slot="inputs" id="userFld">
          <md-icon>face</md-icon>
          <label ref="userLbl">Usuario...</label>
          <md-input
            v-model="userId"
            ref="userTxt"
            @keyup.enter="login()"
            @animationstart="checkAnimation"
          ></md-input>
        </md-field>
        <md-field class="md-form-group" slot="inputs" id="passFld">
          <md-icon>lock_outline</md-icon>
          <label>Password...</label>
          <md-input
            v-model="password"
            type="password"
            ref="passTxt"
            @keyup.enter="login()"
            @animationstart="checkAnimation"
          ></md-input>
        </md-field>
        <md-button slot="footer" class="md-simple md-primary md-lg" @click="login()">Login</md-button>
      </login-card>
    </div>
  </div>
</template>
<script>
import { LoginCard } from "@/components";
import swal from "sweetalert2";

export default {
  components: {
    LoginCard,
  },
  data() {
    return {
      userId: null,
      password: null,
    };
  },
  computed: {
    alert() {
      return this.$store.state.alert.message;
    },
    loginStatus() {
      return this.$store.state.authentication.status;
    },
    empleadoLoaded() {
      return this.$store.state.empleado.status;
    },
  },
  watch: {
    alert() {
      swal({
        title: "Login Incorrecto",
        text: `El usuario o el password no es correcto o no tienes permisos suficientes`,
        type: "error",
        confirmButtonClass: "md-button md-danger btn-fill",
        buttonsStyling: false,
      });
    },
    loginStatus() {
      if (this.loginStatus.loggedIn) {
        let id = this.$store.state.authentication.user._id;
        this.$store.dispatch("empleado/getInfo", id, { root: true });
      }
    },
    empleadoLoaded() {
      if (this.empleadoLoaded.loaded) {
        this.$router.push("/");
      }
    },
  },
  methods: {
    login() {
      const { dispatch } = this.$store;
      const { userId, password } = this;
      dispatch("authentication/login", { userId, password });
    },
    checkAnimation(e) {
      if (e.animationName == "onAutoFillStart") {
      } else if (e.animationName == "onAutoFillCancel") {
        if (e.target.type == "password") {
          setTimeout(function () {
            document.getElementById("passFld").classList.add("md-has-value");
          }, 500);
        } else {
          setTimeout(function () {
            document.getElementById("userFld").classList.add("md-has-value");
          }, 500);
        }
      }
    },
  },
  mounted() {
    let target = this.$refs.userTxt.$el;
    setTimeout(function () {
      target.focus();
    }, 1000);
  },
};
</script>

<style lang="css" scoped>
.img-title {
  width: 150px;
}
</style>
